import { ListReconciliationMismatchesRequest, ListReconciliationMismatchesResponse } from '@cbinsights/salesforceservice/salesforceservice';
import { request } from 'client/modules/common/utils/request';

export const listReconciliationMismatches = (
  req: Partial<ListReconciliationMismatchesRequest>
): Promise<ListReconciliationMismatchesResponse> =>
  request({
    url: '/service/salesforceservice/ListReconciliationMismatches',
    body: req,
  }).then((r) => r.body);
